import * as React from 'react';
import { connect } from 'react-redux';
import { FormAddEdit } from './FormAddEdit';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { formatDropDown, validateAllData, convertNumbers, calculateTotal, persistMaterialInfo, updateFooterTotals, convertDataToDialog, typeAndSizeCheck, originDestinationCols, checkIfSystemType, CBLChargesCols, getInternalReferenceNumberError } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { checkIsValid, isFeatureEnabled, mapReasonCodesToOptions, sortElementByKey } from 'utilities/util';
import { InPageDialog } from 'damco-components';
import { NavCountBar } from 'components/cost-revenue/NavCountBar';
import { INickname } from 'reducers/nickname';
import { DialogTableWrapper } from './DialogTableWrapper';
import { ICostBooking } from 'reducers/bookings/models';
import { IStore } from 'reducers/index';
import { ICustomerList, IMaterialList } from 'reducers/materialMaster';
import { fetchVendors } from 'actions/vendors';
import { resetParties } from 'actions/costRevenue';
import { getMaterialMaster, fetchCustomerMaster } from 'actions/materialMaster';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IQty } from 'constants/costRevModels';
import { ButtonType, Button } from 'components/button';
import { CostAndRevenue } from 'constants/validationMessages';
import { checkVendor, getReasonCodes } from 'actions/mdm';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { costAndRevErrorMessage } from './../../../views/job-costing/utils/models';
import { currentPageMode } from '../../../constants/customs';
import { targetFunctionality } from 'constants/targetFunctionality';
import { fetchVatPartners, fetchVatPartnerEditReasons, fetchVatPartnerValue } from 'actions/vat-partner-edit';
import { fetchExportJobBookingDetails } from 'actions/exportJob';
import { getChargeAmendmentExceptions, getMaterialCodeAttributes, getAdhocContractualRates, getAthenaOptionalChargeRateRetrieval, getChargeSplitRules } from 'actions/athena';
import { useCreateRequestObject } from './useCreateAthenaRateRequest';
import { SplitSelectionTable } from './SplitSelectionTable';
import { ISplitRow, ISplitLevelStrategy, resolveChargeSplitRule, SPLIT_LEVEL_REGISTRY, shouldTriggerSplit, isChargeInSplitBasis } from './splitLevelStrategies';
import { useVatPartnerValueRequestObject } from './useVatPartnerValueRequest';
import { ATHENA } from 'constants/messages';
import { callSettingsApiGet } from 'utilities/apiCaller';
import API from 'constants/api';
import { fetchPartners } from 'actions/partners';
interface IProps {
    shouldDisplay: boolean;
    readonlyState: boolean;
    data: ICostBooking[];
    partyData: any;
    type: string,
    target: any;
    targetFunctionality: number;
    dependencies: any;
    vendorsData?: any[];
    isDestination: boolean;
    onSave: (data: any, target?: any, shouldCloseModal?: boolean) => void;
    onClose: (target: string) => void;
    salesOrderNumber?: string;
    isSourceAthena?: boolean;
    jobId: number;
}

interface IAthenaRateFormData {
    disableAthenaFields: boolean;
    enableAmendRatesButton: boolean;
    showReasonCodeDropdown: boolean;
    athenaRateAdditionalFields: any[];
    isAmendingAutoRates: boolean;
}

interface IState {
    dData: ICostBooking[];
    currentData: any,
    currentIndex: number,
    showDialog: boolean,
    errorMessage: string,
    errorList: string[],
    target: string,
    isReq: boolean,
    type: string,
    isExpanded: boolean;
    shouldUpdate: boolean;
    icbReadOnly: boolean;
    dropDownData: {
        chargeItem: any[],
        partyData: any[];
    },
    table: any,
    subTable: any,
    isAddMoreDisable: boolean,
    isQantityvalidation: boolean,
    consigneeBECode: string,
    showRetriveAndAmendButtons: boolean;
    originalAthenaRateChargeItems: any[];
    editedAthenaRateChargeItems: {
        [index: number]: any;
    };
    athenaRateFormData: {
        [index: number]: IAthenaRateFormData;
    };
    athenaBillToParty: any;
    athenaNetValue: any;
    isAutoRate: boolean;
    highlightTable: boolean;
    isSplitMode: boolean;
    splitStrategy: ISplitLevelStrategy | null;
    splitRows: ISplitRow[];
    selectedSplits: ISplitRow[];
}
interface IMapDispatchToProps {
    fetchPartners: (type: number, valueId: any) => Promise<void>;
    getMaterialMaster: () => Promise<void>;
    fetchCustomerMaster: () => Promise<void>;
    fetchVendors: (country: string, company: string, org: string) => Promise<void>;
    resetParties: () => Promise<void>;
    getReasonCodes: (category: string) => Promise<void>;
    fetchVatPartners: () => void;
    fetchVatPartnerEditReasons: () => void;
    fetchExportJobBookingDetails: (exportJobId: number) => Promise<any>,
    getMaterialCodeAttributes: (customerBeCode: string) => Promise<any>;
    getChargeAmendmentExceptions: (customerBeCode: string) => Promise<any>;
    getAthenaOptionalChargeRateRetrieval: (customerBeCode: string) => Promise<any>;
    getChargeSplitRules: (contractualParty: string, shipmentType: string, chargeCode: string) => Promise<any>;
    getAdhocContractualRates: (documentType: string, requestObject: any) => Promise<any>;
    fetchVatPartnerValue: (documentType: string, requestObject: any) => Promise<any>;
    checkVendor: (code: { beCode?: string; factCode?: string; }) => Promise<any>;
}
interface IMapStateToProps {
    nickname: INickname;
    materialMasterList: IMaterialList[];
    customerlMasterList: ICustomerList[];
    vendors: any[];
    vendorsError: string | string[];
    billToPartnersRawData: any;
    reasonCodes: any[];
    featureToggles: IFeatureToggleModel[];
    vatPartnersData: any;
    vatPartnersOptions: any[];
    vatPartnerEditReasons: any;
    vatPartnerEditReasonSelectOptions: string[];
    userPermissions: any;
    amendmentExceptions: any;
    athenaOptionalChargeRateRetrieval: any;
    chargeSplitRules: any;
    additionalFieldsResponse: any;
    exportJob: any;
    etsJob: any;
    athenaRateRetrieveError: string;
    athenaRetrieveRateResponse: any;
    feedbackResponse: any;
    partners: any[];
}

interface IProperties extends IProps, IMapDispatchToProps, IMapStateToProps { }
export class _AddEditDialog extends React.Component<IProperties, IState> {
    public selectTable: any = React.createRef();
    public myDialog: React.RefObject<any>;
    constructor(props: IProperties) {
        super(props);
        this.state = this.initState();
        this.myDialog = React.createRef();
    }
    public componentDidMount() {
        this.initData();
        this.callFooterUpdate();
        this.setState({
            target: this.props.target,
            type: this.props.type,
            showDialog: false,
            errorMessage: ''
        });
    }
    public componentDidUpdate(nextProps: any, nextState: any) {
        if (this.props.data !== nextProps.data && this.props.data.length > 0) {
            this.initData();
        }
        if (this.props.materialMasterList !== nextProps.materialMasterList && this.props.materialMasterList.length > 0) {
            this.initChargesDropDown();
        }
        if (this.state.table !== nextState.table) {
            this.callFooterUpdate();
        }
        if (this.state.dData !== nextState.dData && this.state.dData.length > 0) {
            const newData = this.state.dData[this.state.currentIndex];
            this.setState({
                currentData: newData
            });
            this.verifyChildren(newData);
            this.callFooterUpdate();
            this.initChargesDropDown();
        }
        if (this.state.showDialog !== nextState.showDialog && this.state.showDialog) {
            window.scrollTo(0, 0);
        }
        if (this.props.feedbackResponse !== nextProps.feedbackResponse &&
            this.props.feedbackResponse && JSON.stringify(this.props.feedbackResponse) !== '{}') {
            const editedAthenaRateChargeItems = { ...this.state.editedAthenaRateChargeItems };
            const updatedItems = Object.keys(editedAthenaRateChargeItems).reduce((acc: any, key: any) => {
                const item = editedAthenaRateChargeItems[key];

                const identifier = item.AdhocContractualAmendmentIdentifier;
                item.specialPricingCondition = 'N';
                item.netValue = this.updateNetValueWhenEdited(item.rate, item.quantity, item.dynamicFields);
                item.itemType = ATHENA;
                item.updatedBy = this.props.nickname.employeeId;
                item.AdhocContractualAmendmentIdentifier = '';
                item.rowVersion = this.props.feedbackResponse[identifier].rowVersion;
                item.essoRateDetailId = this.props.feedbackResponse[identifier].chargeDetailId;
                item.VatPartnerIdentifier = '';
                acc[key] = item;
                return acc;
            }, {});
            this.props.onSave(Object.values(updatedItems), this.props.target, true);
        }
    }
    public componentWillUnmount() {
        this.setState(this.initState());
        this.props.resetParties();
    }

    public initState = () => {
        return {
            dData: [],
            currentData: {},
            currentIndex: -1,
            showDialog: false,
            errorMessage: '',
            errorList: [],
            target: '',
            type: '',
            shouldUpdate: false,
            isExpanded: false,
            table: {},
            subTable: React.createRef(),
            isReq: false,
            icbReadOnly: true,
            dropDownData: {
                chargeItem: [],
                partyData: []
            },
            isAddMoreDisable: false,
            isQantityvalidation: false,
            consigneeBECode: '',
            showRetriveAndAmendButtons: false,
            originalAthenaRateChargeItems: [],
            editedAthenaRateChargeItems: {},
            athenaRateFormData: {},
            athenaBillToParty: {},
            athenaNetValue: null,
            isAutoRate: false,
            highlightTable: false,
            isSplitMode: false,
            splitStrategy: null,
            splitRows: [],
            selectedSplits: [],
        };
    };

    public initData = () => {
        if (this.props.type === currentPageMode.edit) {
            const category = this.props.isDestination ? 'ISSO' : 'ESSO';
            this.props.getReasonCodes(category);
        }
        if (this.props.materialMasterList.length === 0) {
            this.props.getMaterialMaster();
        } else {
            this.initChargesDropDown();
        }
        // arr spread was cloning with reference
        let newData = JSON.parse(JSON.stringify(this.props.data));
        if (this.props.dependencies && this.props.type === currentPageMode.add) {
            newData[0].children = this.props.dependencies;
            newData[0].delete = 'Remove';
        } else if (this.props.type !== currentPageMode.add) {
            newData = convertDataToDialog(newData);
        }
        this.props.fetchVatPartners();
        this.props.fetchVatPartnerEditReasons();
        this.setState({
            dData: newData,
            currentIndex: 0,
            currentData: { ...newData[0] },
            target: this.props.target,
            type: this.props.type,
        }, async (): Promise<any> => {
            if (this.props.type === currentPageMode.add && this.isAthenaEnabled() && !typeAndSizeCheck(this.state.dData)) {
                newData[0].displayDistribution = true;
            }
            const docId = newData.flatMap((item: any) => item.children || [])
                .find((child: any) => child.DocumentId)?.DocumentId;
            if (docId && this.props.isSourceAthena) {
                try {
                    const response: any = await this.props.fetchExportJobBookingDetails(docId);
                    const consigneeBECode: any = response.bookings[0].consigneeBusinessEntityCode;
                    if (consigneeBECode) {
                        await this.props.getMaterialCodeAttributes(consigneeBECode);
                        await this.props.getChargeAmendmentExceptions(consigneeBECode);
                        await this.props.getAthenaOptionalChargeRateRetrieval(consigneeBECode);
                        this.setState({
                            consigneeBECode
                        }, () => {
                            this.checkAthenaFieldsStatus();
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        });
    };

    public showTable = (): any[] => {
        return this.props.targetFunctionality === 3 ? CBLChargesCols(this.props.target)
            : originDestinationCols(this.props.isDestination, this.props.target);
    };

    public deleteChargeItem = (item: any, selectedTable: any) => {
        const newData = [...this.state.dData.filter((el: any) => el.id !== item.id)];
        if (newData.length > 0 && newData.length <= 10) {
            this.setState({
                dData: [...newData],
                currentData: newData[0],
                currentIndex: 0,
                isAddMoreDisable: false
            });
        } else {
            this.onClose();
        }
    };

    public isAthenaEnabled = () => this.props.isSourceAthena && this.props.type === currentPageMode.add;

    public getMaterialException = (
        data: any[],
        materialCode: number
    ) => {
        if (!data || !Array.isArray(data) || data.length === 0) {
            return undefined;
        }

        return (
            data.find(
                (exception) =>
                    Number(exception.materialCode) === materialCode &&
                    exception.customerBeCode.toLowerCase() === this.state.consigneeBECode.toLowerCase()
            ) ??
            data.find(
                (exception) =>
                    Number(exception.materialCode) === materialCode &&
                    exception.customerBeCode === '*'
            )??
            data.find(
                (exception) =>
                    exception.materialCode === '*' &&
                    exception.customerBeCode.toLowerCase() === this.state.consigneeBECode.toLowerCase()
            )
        );
    };

    public checkIfAmendRatesEnabled = (materialCode: number) => {
        if (!this.isAthenaEnabled() || !materialCode || !this.props.amendmentExceptions.data?.length) {
            return false;
        };

        const allowedMaterialCode = this.getMaterialException(this.props.amendmentExceptions.data, materialCode);
        const documentType = this.props.isDestination ? 'import' : 'export';
        return !!(allowedMaterialCode &&
            allowedMaterialCode.documentType.toLowerCase() === documentType &&
            allowedMaterialCode.amendmentAllowed);
    };

    public checkForAdditionalFields = (materialCode: number) => {
        const allowedMaterialCode = this.getMaterialException(this.props.additionalFieldsResponse.data, materialCode);
        const isAutoRateEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_AUTO_PRICE_RETRIEVAL_FROM_ATHENA, this.props.featureToggles);
        let additionalFields = isAutoRateEnabled && allowedMaterialCode?.isEnabled ? this.parseRuleJson(allowedMaterialCode.ruleJson) : null;

        if (additionalFields && additionalFields.length > 0 && this.state.currentData.dynamicFields && this.props.type === currentPageMode.edit) {
            try {
                const dynamicFields = JSON.parse(this.state.currentData.dynamicFields);
                additionalFields = additionalFields.map((field: any) => {
                    const dynamicField = dynamicFields?.find((df: any) => df.key === field.key);
                    if (dynamicField) {
                        field.value = dynamicField.value;
                    }
                    return field;
                });
            } catch (error) {
                console.error('Error parsing dynamicFields:', error);
            }
        } else {
            this.state.currentData.dynamicFields = '';
        }

        this.setState((prevState) => ({
            athenaRateFormData: {
                ...prevState.athenaRateFormData,
                [this.state.currentData.id]: {
                    ...prevState.athenaRateFormData[this.state.currentData.id],
                    athenaRateAdditionalFields: additionalFields || []
                }
            }
        }));
    };

    public parseRuleJson(ruleJson: string) {
        try {
            if (typeof ruleJson === 'string') {
                if (ruleJson.startsWith('\"') && ruleJson.endsWith('\"')) {
                    ruleJson = ruleJson.slice(1, -1);
                }
                ruleJson = ruleJson.replace(/\\"/g, '"');
                const cleanedJsonString = ruleJson
                    .replace(/\s+/g, ' ')
                    .replace(/\n|\r/g, ' ')
                    .trim();
                const parsedJson = JSON.parse(cleanedJsonString);
                const transformedJson = parsedJson.map((item: any) => {
                    return {
                        key: item.key,
                        type: item.type,
                        displayName: item.displayName,
                        options: item.value || [],
                        value: '',
                        required: item.hasOwnProperty('required') ? item.required : true,
                        hasError: false,
                        errorMessage: ''
                    };
                });
                return transformedJson;
            } else {
                return ruleJson;
            }
        } catch (e) {
            console.error('Error parsing ruleJson:', e);
            return null;
        }
    }

    public checkAthenaFieldsStatus = () => {
        const isAutoRateEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_AUTO_PRICE_RETRIEVAL_FROM_ATHENA, this.props.featureToggles);
        const hasMatchingBECode = this.props.athenaOptionalChargeRateRetrieval?.data?.some(
            (row: any) => (row.customerBeCode.toLowerCase() === this.state.consigneeBECode.toLowerCase() && 
                                    row.isEnabled && 
                                    row.documentType.toLowerCase() === (this.props.isDestination ? 'import' : 'export'))
        );
        this.setState((prevState) => ({
            showRetriveAndAmendButtons: isAutoRateEnabled && hasMatchingBECode,
            athenaRateFormData: {
                ...prevState.athenaRateFormData,
                [this.state.currentData.id]: {
                    disableAthenaFields: isAutoRateEnabled && hasMatchingBECode,
                    enableAmendRatesButton: false,
                    showReasonCodeDropdown: false,
                    athenaRateAdditionalFields: [],
                    isAmendingAutoRates: false,
                }
            }
        }), () => {
            this.checkForAdditionalFields(Number(this.state.currentData.chargeItem));
        });
    };

    public onAthenaAdditionalFieldsUpdate = (additionalFields: any) => {
        const athenaRateAdditionalFields = this.state.athenaRateFormData[this.state.currentData.id]?.athenaRateAdditionalFields;
        athenaRateAdditionalFields.map((field: any) => {
            const updatedField = additionalFields.find((af: any) => af.key === field.key);
            if (updatedField) {
                field.value = updatedField.value;
            }
            return field;
        });
        const currentIndex = [...this.state.dData];
        if (additionalFields?.length) {
            const DynamicFields = additionalFields.map((field: any) => {
                return {
                    key: field.key,
                    value: field.value
                };
            });
            currentIndex[this.state.currentIndex].dynamicFields = JSON.stringify(DynamicFields);
        };
    };
    /** A shipment is GCA when the GCA config has an entry for its sales area + contractual party. */
    public isGcaShipment = async (salesArea: string): Promise<boolean> => {
        await this.props.fetchPartners(this.props.targetFunctionality, this.props.jobId);
        const contractualParty = this.props.partners.find((partner: any) => partner.partnerType === 'ContractualParty');
        const page = 1;
        const limit = 10000;
        const gcaConfigurations = await  callSettingsApiGet(API.FinanceConfig.GcaConfiguration, { salesArea: salesArea?.substring(0, 4), customerBeCode: contractualParty?.beCode, page, limit });
        return gcaConfigurations?.data?.data.length > 0;
    }

    public isAdditionalIncotermNeeded = async (salesArea: string) => {
        if (!isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ATHENA_ADDITIONAL_INCOTERMS, this.props.featureToggles)) {
            return false;
        }
        return !(await this.isGcaShipment(salesArea));
    }

    public fetchAutoRate = async (additionalFieldsError: string = '', additionalFields: any) => {
        const { isValid, invalidKeys, invalidList } = this.autoRateRequestValidation();
        const isFormValid = isValid && additionalFieldsError === '';
        const errorMessage = 'Please fill all the required fields before fetching rates: ';
        const { isAtleastOneSelected, haveSameSizeAndType, selectedContainerSize, selectedContainerType } = this.validateContainerSizeAndType(this.state.currentData.children);
        if (!isAtleastOneSelected) {
            this.setState({
                showDialog: true,
                errorMessage: CostAndRevenue.Error_Select_Distribution,
                highlightTable: true
            });
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth',
            });
            return;
        }
        if (!haveSameSizeAndType) {
            this.setState({
                showDialog: true,
                errorMessage: CostAndRevenue.Container_Error_Fetch_Athena,
                highlightTable: true
            });
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth',
            });
            return;
        }

        this.setState({
            isAutoRate: true,
            showDialog: !isFormValid,
            errorMessage: isFormValid ? '' : `${errorMessage}${invalidList.join(', ')},${additionalFieldsError}`,
            errorList: isFormValid ? [] : invalidKeys,
            highlightTable: false
        });

        if (isValid && additionalFieldsError === '') {
            const documentType = this.props.isDestination ? 'Import' : 'Export';
            const exportStore = this.props.exportJob;
            const importStore = this.props.etsJob;
            const currentFormData = this.state.currentData;
            const isAdditionalIncotermNeeded = await this.isAdditionalIncotermNeeded(
                documentType === 'Export'
                ? exportStore.exportJobDetails.salesArea
                : importStore.etsDetails.salesAreaRev,
            );
            const requestObject = useCreateRequestObject(
                documentType,
                currentFormData,
                exportStore,
                importStore,
                this.props.billToPartnersRawData,
                additionalFields,
                selectedContainerSize,
                selectedContainerType,
                isAdditionalIncotermNeeded,
                this.state.isSplitMode ? this.state.selectedSplits : [],
                this.state.splitStrategy?.referenceType
            );
            this.setState((prevState) => ({
                athenaRateFormData: {
                    ...prevState.athenaRateFormData,
                    [this.state.currentData.id]: {
                        ...prevState.athenaRateFormData[this.state.currentData.id],
                        enableAmendRatesButton: true,
                    }
                }
            }));
            await this.props.getAdhocContractualRates(documentType, requestObject).then((data) => {
                this.updateFieldsWithAthenaRates(data);
            })
                .catch((error) => {
                    this.setState({
                        showDialog: true,
                        errorMessage: error
                    });
                });
            this.getVatPartnerFieldValue();
        };
    };

    public validateContainerSizeAndType = (rows: any[]) => {
        const selected = rows.filter(row => row.Select);
        const isAtleastOneSelected = selected.length > 0;

        const haveSameSizeAndType = isAtleastOneSelected
            ? selected.every(
                row =>
                    row.containerSize === selected[0].containerSize &&
                    row.containerType === selected[0].containerType
            )
            : false;

        return {
            isAtleastOneSelected,
            haveSameSizeAndType,
            selectedContainerSize: selected[0]?.containerSize || '',
            selectedContainerType: selected[0]?.containerType || ''
        };
    };

    public getContractualParty = (): string | undefined => {
        return this.props.isDestination
             ? (this.props.etsJob?.etsDetails?.contractualParty || undefined)
             : (this.props.exportJob?.exportJobDetails?.contractualParty || undefined);
    };

    /**
     * When a charge is selected, fetch its split rules (filtered by contractual party, shipment
     * type, ruleType and chargeCode) and, once they arrive, apply the split state. The thunk
     * resolves with the fetched rules so we don't race the redux prop update.
     */
    public loadSplitRulesForCharge = (materialCode: string | number | undefined) => {
        if (!isFeatureEnabled(FEATURE_TOGGLES.FINOPS_CHARGE_SPLIT_ENABLED, this.props.featureToggles)) {
            return;
        }
        // Charge-split only applies while adding a charge. The per-SBK fan-out is driven by the
        // Athena rate fetch (Retrieve Rates), which is add-mode only — in edit mode there is no
        // way to refresh rates per SBK, so showing the SBK split table would only produce a
        // broken half-state (combined quantity, no split reference, stale rate). Skip it in edit.
        if (this.props.type !== currentPageMode.add) {
            return;
        }
        const contractualParty = this.getContractualParty();
        if (!contractualParty || !materialCode) {
            return;
        }
        const shipmentType = this.props.isDestination ? 'Import' : 'Export';
        // Capture the row + charge this request is for, so we can drop a stale response if the
        // user navigates to another row / changes the charge while the fetch is in flight.
        const requestIndex = this.state.currentIndex;
        const isStale = () =>
            this.state.currentIndex !== requestIndex ||
            String(this.state.dData[requestIndex]?.materialCode) !== String(materialCode);
        return this.props.getChargeSplitRules(contractualParty, shipmentType, String(materialCode))
            .then(async (payload: any) => {
                if (isStale()) {
                    return; // stale response — the current row/charge changed since the request
                }
                const rules = Array.isArray(payload?.data) ? payload.data : [];
                // SBK x lane split: the lane source depends on GCA vs non-GCA, so look the
                // shipment up in the GCA config before building rows. Failure => non-GCA.
                let isGca = false;
                if (this.needsGcaLookup(materialCode, rules)) {
                    try {
                        isGca = await this.isGcaShipment(this.getSplitSource().salesArea);
                    } catch {
                        isGca = false;
                    }
                    if (isStale()) {
                        return;
                    }
                }
                const splitState = this.computeSplitState(materialCode, rules, isGca);
                const dData = [...this.state.dData];
                if (splitState.isSplitMode && dData[requestIndex]) {
                    dData[requestIndex] = {
                        ...dData[requestIndex],
                        quantity: this.combinedSplitQuantity(splitState.selectedSplits),
                    };
                }
                this.setState({ ...splitState, dData, currentData: dData[requestIndex] });
            })
            .catch(() => { /* leave as non-split */ });
    };

    /**
     * Resolve whether the given charge is split across a shipment level (SBK / FCR / ...).
     * Used by Import and Export; the rule's shipmentType gates which rules apply.
     * `rules` can be passed explicitly (from the fetch result) to avoid racing the redux prop.
     */
    public computeSplitState = (materialCode: string | number | undefined, rules?: any[], isGca: boolean = false) => {
        const documentType = this.props.isDestination ? 'Import' : 'Export';
        const ruleData = rules !== undefined ? rules : this.props.chargeSplitRules?.data;
        const rule = resolveChargeSplitRule(ruleData, {
            contractualParty: this.getContractualParty(),
            materialCode,
            shipmentType: documentType,
        });
        const strategy = rule ? SPLIT_LEVEL_REGISTRY[rule.splitLevel] ?? null : null;
        const noSplit = { isSplitMode: false, splitStrategy: null, splitRows: [], selectedSplits: [] };
        if (!rule || !strategy) {
            return noSplit;
        }
        // The rule's TriggerType / SplitBasis decide whether this charge is split.
        if (!this.isSplitApplicable(rule)) {
            return noSplit;
        }
        const source = this.getSplitSource();
        const splitRows = strategy.getRows(
            { bookings: source.bookings },
            { isGca, equipmentLaneIds: source.equipmentLaneIds },
        );
        // All rows are selected by default (total quantity shown); the user can deselect.
        return { isSplitMode: true, splitStrategy: strategy, splitRows, selectedSplits: [...splitRows] };
    };

    /**
     * Booking / lane / flag source per flow.
     *  - Import/ETS: etsDetails.shipment.bookings lists every SBK connected to the ETS (covering
     *    SBKs spanning several export jobs); non-GCA lanes come from each booking's `clrLaneIds`
     *    (array); without it they fall back to etsDetails.equipments[].laneIds.
     *  - Export: export-job/{id}/bookings (exportDetailsBooking.bookings). Each booking carries its
     *    own connected equipments[].laneIds, so there is no job-level equipment lane list.
     */
    public getSplitSource = (): {
        bookings: any[];
        equipmentLaneIds: string[];
        isInvoiceSplitRequired?: boolean;
        salesArea: string;
    } => {
        if (this.props.isDestination) {
            const ets = this.props.etsJob?.etsDetails;
            return {
                bookings: ets?.shipment?.bookings || [],
                equipmentLaneIds: (ets?.equipments || []).reduce(
                    (laneIds: string[], e: any) => laneIds.concat(e?.laneIds || []),
                    [],
                ),
                isInvoiceSplitRequired: ets?.isInvoiceSplitRequired,
                salesArea: ets?.salesAreaRev,
            };
        }
        const exportJob = this.props.exportJob;
        return {
            bookings: exportJob?.exportDetailsBooking?.bookings || [],
            equipmentLaneIds: [],
            isInvoiceSplitRequired: exportJob?.exportDetailsBooking?.isInvoiceSplitRequired,
            salesArea: exportJob?.exportJobDetails?.salesArea,
        };
    };

    /** The rule applies to this charge: its trigger type is met and its split basis covers rev / cost. */
    public isSplitApplicable = (rule: any): boolean =>
        !!rule
        && shouldTriggerSplit(rule, this.getSplitSource().isInvoiceSplitRequired)
        && isChargeInSplitBasis(rule, this.props.target === CostColumnsData.TYPES.REVENUE);

    /** True when a rule applies to this charge, so the GCA lookup (lane source) is needed. */
    public needsGcaLookup = (materialCode: string | number | undefined, rules: any[]): boolean =>
        this.isSplitApplicable(resolveChargeSplitRule(rules, {
            contractualParty: this.getContractualParty(),
            materialCode,
            shipmentType: this.props.isDestination ? 'Import' : 'Export',
        }));

    /** Combined (summed) quantity across the given split rows (one row per SBK). */
    public combinedSplitQuantity = (splits: ISplitRow[]): number =>
        splits.reduce((sum: number, s: ISplitRow) => sum + Number(s.quantity || 0), 0);

    public onSplitSelectionChange = (selectedSplits: ISplitRow[]) => {
        // Normalize to the canonical split rows by id — the table's getSelectedItems() may
        // return a table-internal shape, so this guarantees `number`/`quantity` are the real
        // values (used for the request referenceNumber/quantity).
        const normalized = (selectedSplits || [])
            .map((sel: any) => this.state.splitRows.find((r: ISplitRow) => r.id === sel.id) || sel)
            .filter(Boolean);
        // Reflect the combined quantity of the selected bookings in the (read-only) Quantity field.
        const dData = [...this.state.dData];
        if (dData[this.state.currentIndex]) {
            dData[this.state.currentIndex] = {
                ...dData[this.state.currentIndex],
                quantity: this.combinedSplitQuantity(normalized),
            };
        }
        this.setState({
            selectedSplits: normalized,
            dData,
            currentData: dData[this.state.currentIndex],
        });
    };

    public autoRateRequestValidation = () => {
        const { target } = this.props;
        const isRevenue = target === CostColumnsData.TYPES.REVENUE;
        const { dData, currentIndex } = this.state;
        const currentData = { ...dData[currentIndex] };
        const quantityRegex = /^\d{0,6}(\.\d{1,3})?$/;
        const requiredFields = [
            { key: 'chargeItem', message: 'Charge Item', condition: !currentData.chargeItem },
            { key: 'uom', message: 'UOM', condition: !currentData.uom },
            { key: 'payToParty', message: 'Pay to Party', condition: !isRevenue && !currentData.payToParty },
        ];
        if (this.state.isSplitMode) {
            // Quantity is derived per split entity and the input is disabled; require a selection instead.
            requiredFields.push({
                key: 'selectedSplits',
                message: `Select at least one ${this.state.splitStrategy?.referenceType || 'split'}`,
                condition: !this.state.selectedSplits.length,
            });
        } else {
            requiredFields.push({
                key: 'quantity', message: 'QTY - must be a number', condition:
                    !currentData.quantity ||
                    parseFloat(currentData.quantity.toString()) === 0 ||
                    !quantityRegex.test(currentData.quantity.toString())
            });
        }

        const invalidFields = requiredFields.filter(field => field.condition);
        return {
            invalidKeys: invalidFields.map(field => field.key),
            invalidList: invalidFields.map(field => field.message),
            isValid: invalidFields.length === 0,
        };
    };

    public amendAthenaRates = () => {
        const currentData = [...this.state.dData];
        if (!currentData[this.state.currentIndex].AdhocContractualAmendmentIdentifier) {
            currentData[this.state.currentIndex].AdhocContractualAmendmentIdentifier = Math.random().toString(36).substring(2);
            this.setState((prevState) => {
                return {
                    originalAthenaRateChargeItems: [
                        ...prevState.originalAthenaRateChargeItems,
                        JSON.stringify(currentData[this.state.currentIndex])
                    ]
                };
            });
        }

        this.setState((prevState) => ({
            athenaRateFormData: {
                ...prevState.athenaRateFormData,
                [this.state.currentData.id]: {
                    ...prevState.athenaRateFormData[this.state.currentData.id],
                    disableAthenaFields: false,
                    showReasonCodeDropdown: true,
                    isAmendingAutoRates: true,
                }
            }
        }));
    };

    public updateFieldsWithAthenaRates = (data: any) => {
        const charges = data?.addedCharges || [];
        if (this.state.isSplitMode && charges.length > 0) {
            this.applySplitAthenaRates(charges);
            return;
        }
        const currentIndex = [...this.state.dData];
        currentIndex[this.state.currentIndex].rate = data.addedCharges[0]?.unitPrice ?? null;
        currentIndex[this.state.currentIndex].condCurrency = data.addedCharges[0]?.currency || '';
        currentIndex[this.state.currentIndex].passThrough = data.addedCharges[0]?.passThroughIndicator === 'YES' ? 'Y' : 'N';
        currentIndex[this.state.currentIndex].serviceRenderedAt = data.addedCharges[0]?.serviceRenderedAt || '';
        currentIndex[this.state.currentIndex].ChargeType = data.addedCharges[0]?.chargeType || '';
        currentIndex[this.state.currentIndex].Applicability = data.addedCharges[0]?.applicability || '';
        currentIndex[this.state.currentIndex].AthenaRateIdentifier = data.addedCharges[0]?.itemNumber || '';
        currentIndex[this.state.currentIndex].specialPricingCondition = data.addedCharges[0]?.specialPricingCondition ? 'Y' : 'N';
        currentIndex[this.state.currentIndex].netValue = data.addedCharges[0]?.netValue || '';
        currentIndex[this.state.currentIndex].chargeValidityBased = data.addedCharges[0]?.chargeBasedOn || '';
        currentIndex[this.state.currentIndex].contractStartDate = data.addedCharges[0]?.startDate || '';
        currentIndex[this.state.currentIndex].contractEndDate = data.addedCharges[0]?.endDate || '';
        currentIndex[this.state.currentIndex].secondaryRateIdentifier = data.addedCharges[0]?.secondaryRateIdentifier || '';

        if (data.addedCharges[0]?.billToPartyFactCode) {
            this.props.checkVendor({ factCode: data.addedCharges[0].billToPartyFactCode })
                .then((athenaData) => {
                    if (athenaData?.factCode && athenaData?.scvNumber && athenaData?.name && athenaData?.beCode) {
                        currentIndex[this.state.currentIndex].others = `${athenaData?.beCode} - ${athenaData?.factCode} - ${athenaData?.name}`;
                        currentIndex[this.state.currentIndex].billToParty = athenaData?.factCode;
                        currentIndex[this.state.currentIndex].billToPartyName = athenaData?.name;
                        this.setState({
                            athenaBillToParty: {
                                partnerType: 'BillToParty',
                                country: athenaData?.country,
                                beCode: athenaData?.beCode,
                                funcCode: athenaData?.funcCode,
                                factCode: athenaData?.factCode,
                                name: athenaData?.name,
                                scV_SCACCode: athenaData?.scV_SCACCode,
                                showInDropdown: 'Y',
                                revOrCost: 'REV',
                            },
                        });
                    }
                }).catch((error) => {
                    this.setState({
                        showDialog: true,
                        errorMessage: 'Failed to fetch bill to party details'
                    });
                });
        }

        this.setState({
            athenaNetValue: data.addedCharges[0]?.netValue || null,
            dData: currentIndex,
            currentData: currentIndex[this.state.currentIndex]
        });
    };

    /**
     * Split mode: the response carries one charge per selected split entity, each echoing the
     * referenceNumber (booking number) it was requested with. Fan the single edited row out
     * into one row per response charge, matching each to its booking strictly by referenceNumber.
     * Quantity is the response quantity when special pricing applies (Burlington; null otherwise),
     * else the matched booking's volume. Order-independent; no index fallback.
     */
    public applySplitAthenaRates = (charges: any[]) => {
        const template = this.state.dData[this.state.currentIndex];
        const referenceType = this.state.splitStrategy?.referenceType || '';
        let maxId = Math.max(0, ...this.state.dData.map((d: any) => Number(d.id) || 0));
        const newRows = charges.map((ch: any, i: number) => {
            // Deep-clone so each row is an independent add/edit "page" (own children/ids),
            // exactly like charges added one-by-one from the UI.
            const row = JSON.parse(JSON.stringify(template));
            // Match strictly by the echoed referenceNumber (booking number); order is not
            // guaranteed, so we never map by position.
            // The selected SBK row is matched by SBK number; its lane is the one echoed by the
            // response (one charge comes back per SBK x lane).
            const match = this.state.selectedSplits.find((s: ISplitRow) => s.number === ch.referenceNumber);
            row.id = i === 0 ? template.id : ++maxId;
            row.delete = 'Remove';
            row.splitReferenceType = referenceType;
            row.splitReferenceNumber = ch.referenceNumber || match?.number;
            row.splitLaneId = ch.laneId || (match?.lanes?.length === 1 ? match.lanes[0] : null);
            // Quantity: when special pricing applies, the response carries the quantity to use
            // (Burlington only; null for other customers). Otherwise use the matched booking's
            // volume. template.quantity (the combined total) is never used for a per-booking row.
            row.quantity = (ch.specialPricingCondition && ch.quantity != null)
                ? ch.quantity
                : (match?.quantity ?? 0);
            row.rate = ch.unitPrice ?? null;
            row.condCurrency = ch.currency || '';
            row.passThrough = ch.passThroughIndicator === 'YES' ? 'Y' : 'N';
            row.serviceRenderedAt = ch.serviceRenderedAt || '';
            row.ChargeType = ch.chargeType || '';
            row.Applicability = ch.applicability || '';
            row.AthenaRateIdentifier = ch.itemNumber || '';
            row.specialPricingCondition = ch.specialPricingCondition ? 'Y' : 'N';
            row.netValue = ch.netValue || '';
            row.chargeValidityBased = ch.chargeBasedOn || '';
            row.contractStartDate = ch.startDate || '';
            row.contractEndDate = ch.endDate || '';
            row.secondaryRateIdentifier = ch.secondaryRateIdentifier || '';
            // Re-key this row's distribution children so ids stay unique across pages.
            if (Array.isArray(row.children)) {
                row.children.forEach((el: any, index: number) => {
                    el.id = `${row.id}.${index}`;
                });
            }
            return row;
        });
        const dData = [...this.state.dData];
        dData.splice(this.state.currentIndex, 1, ...newRows);
        this.setState({
            dData,
            currentData: dData[this.state.currentIndex],
            athenaNetValue: charges[0]?.netValue || null,
        });
        // Enrich bill-to party per response entry (async), matching rows by id.
        charges.forEach((ch: any, i: number) => {
            if (ch?.billToPartyFactCode) {
                this.enrichSplitRowBillToParty(newRows[i].id, ch.billToPartyFactCode);
            }
        });
    };

    public enrichSplitRowBillToParty = (rowId: any, factCode: string) => {
        this.props.checkVendor({ factCode })
            .then((athenaData: any) => {
                if (athenaData?.factCode && athenaData?.scvNumber && athenaData?.name && athenaData?.beCode) {
                    this.setState((prevState) => ({
                        dData: prevState.dData.map((row: any) =>
                            row.id === rowId
                                ? {
                                    ...row,
                                    others: `${athenaData.beCode} - ${athenaData.factCode} - ${athenaData.name}`,
                                    billToParty: athenaData.factCode,
                                    billToPartyName: athenaData.name,
                                }
                                : row),
                    }));
                }
            })
            .catch(() => {
                this.setState({ showDialog: true, errorMessage: 'Failed to fetch bill to party details' });
            });
    };

    public updateNetValueWhenEdited = (rate: any, quantity: any, dynamicFieldsJson: any) => {
        let baseAmount = rate * quantity;
        let dynamicFields: any[] = [];
        if (dynamicFieldsJson) {
            try {
                dynamicFields = JSON.parse(dynamicFieldsJson);
            } catch (error) {
                dynamicFields = [];
            }
            const daysField = dynamicFields.find(field => field.key.endsWith('Days'));
            const noOfDays = daysField ? daysField.value : null;
            if (noOfDays) {
                baseAmount = baseAmount * noOfDays;
            }
        }
        return baseAmount;
    };

    public getVatPartnerOptions = (vatPartnerValue: string) => {
        const isVatPartnerInOptions = this.props.vatPartnersOptions?.find((vatPartner: any) => vatPartner?.value === vatPartnerValue);
        if (isVatPartnerInOptions) {
            return this.props.vatPartnersOptions;
        }
        return [
            ...this.props.vatPartnersOptions,
            {
                value: vatPartnerValue,
                optionText: vatPartnerValue,
                label: vatPartnerValue,
            },
        ];
    };

    public getVatPartnerFieldValue = async () => {
        const allowEditVatPartner = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ENABLE_VATPARTNER_AMENDMENT, this.props.featureToggles);
        const isRevenue = this.props.target === CostColumnsData.TYPES.REVENUE;
        if (allowEditVatPartner && isRevenue) {
            const documentType = this.props.isDestination ? 'Import' : 'Export';
            const exportStore = this.props.exportJob;
            const importStore = this.props.etsJob;
            const currentFormData = this.state.currentData;
            const currentData = [...this.state.dData];
            const vatPartnerValueRequestObject = useVatPartnerValueRequestObject(
                currentFormData,
                documentType,
                exportStore,
                importStore
            );
            await this.props.fetchVatPartnerValue(documentType, vatPartnerValueRequestObject).then((data) => {
                if (data?.codeDetail) {
                    this.updateVatPartnerFieldWithValue(data.codeDetail);
                }
                if (data?.errorMessage) {
                    const message = data.errorMessage || 'VAT Partner not found';
                    currentData[this.state.currentIndex].VatPartnerValueError = data.errorMessage;
                    this.setState({
                        showDialog: true,
                        errorMessage: this.state.errorMessage ? `1) ${this.state.errorMessage} 2) ${message}` : message,
                        dData: currentData,
                        currentData: currentData[this.state.currentIndex]
                    });
                }
            })
                .catch((error) => {
                    const message = error || 'VAT partner not found';
                    currentData[this.state.currentIndex].VatPartnerValueError = message;
                    this.setState({
                        showDialog: true,
                        errorMessage: this.state.errorMessage ? `1) ${this.state.errorMessage} 2) ${message}` : message,
                    });
                });
        }
    };

    public updateVatPartnerFieldWithValue = (vatPartnerData: any) => {
        const currentIndex = [...this.state.dData];
        currentIndex[this.state.currentIndex].vatPartner = vatPartnerData.vatPartnerCode || '';
        currentIndex[this.state.currentIndex].VatPartnerIdentifier = vatPartnerData.uniqueIdentifier || '';
        this.setState({
            dData: currentIndex,
            currentData: currentIndex[this.state.currentIndex]
        });
    };

    public showErrorModal = (message: string) => {
        this.setState({
            showDialog: true,
            errorMessage: message
        });
    };

    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isPassThroughEnabled = isFeatureEnabled(FEATURE_TOGGLES.ENABLE_PASSTHROUGH, this.props.featureToggles);
        const allowEditVatPartner = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ENABLE_VATPARTNER_AMENDMENT, this.props.featureToggles);
        const showServiceProvider = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ATHENA_PAYTOPARTY_FOR_ADHOC_CONTRACTUAL_RATE_DERIVATION, this.props.featureToggles);
        const hasJobCostingExecutePermission = this.props.userPermissions?.permissions?.some((permission: any) => permission.businessCapabilityName === 'FinOps (Job Costing)' &&
            permission.permission === 'Execute');
        const materialCode = this.state.currentData?.materialCode;
        const disableAthenaFields = this.state.athenaRateFormData[this.state.currentData.id]?.disableAthenaFields;
        const enableAmendRatesButton = this.state.athenaRateFormData[this.state.currentData.id]?.enableAmendRatesButton;
        const showReasonCodeDropdown = this.state.athenaRateFormData[this.state.currentData.id]?.showReasonCodeDropdown;
        const athenaRateAdditionalFields = this.state.athenaRateFormData[this.state.currentData.id]?.athenaRateAdditionalFields;
        const isAmendingAutoRates = this.state.athenaRateFormData[this.state.currentData.id]?.isAmendingAutoRates;
        const isNegativeRateAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ALLOW_NEGATIVE_RATE, this.props.featureToggles);
        const systemUsers = ['ATHENA', 'SAP'];
        const isInsertedByUser = this.state.dData.every((obj: any) => !systemUsers.includes(obj.insertBy));
        return (
            <div>
                <div className="grid-wrapper">
                    <h2 className="col-70">{this.getTitle()}</h2>
                    {this.getButtons()}
                </div>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMessage}
                    closeMethod={this.closeDialog} />
                <NavCountBar
                    currentIndex={this.state.currentIndex + 1}
                    totalIndex={this.state.dData.length}
                    onClick={this.nextPrevClick} />
                <div ref={this.myDialog}>
                    {this.props.shouldDisplay === true && this.state.currentIndex !== -1 && this.state.dropDownData && this.state.dropDownData.chargeItem.length > 0 &&
                        <FormAddEdit
                            targetFunctionality={this.props.targetFunctionality}
                            propsData={this.props.data[this.state.currentIndex]}
                            data={this.state.currentData}
                            readonlyState={this.props.readonlyState}
                            icbReadonlyState={this.state.icbReadOnly}
                            type={this.state.type}
                            target={this.state.target}
                            dropDownData={this.state.dropDownData}
                            errorList={this.state.errorList}
                            onUpdate={this.onUpdate}
                            onClose={this.onClose}
                            onAthenaAdditionalFieldsUpdate={this.onAthenaAdditionalFieldsUpdate}
                            onFetchAutoRate={this.fetchAutoRate}
                            onAmendRates={this.amendAthenaRates}
                            reasonCodes={this.props.reasonCodes && mapReasonCodesToOptions(this.props.reasonCodes)}
                            hasSplit={true}
                            onAddMore={this.onAddClick}
                            addMoreDisable={this.state.isAddMoreDisable}
                            isQantityError={this.state.isQantityvalidation}
                            displayError={this.state.showDialog && this.props.target === CostColumnsData.TYPES.REVENUE ? true : false}
                            showPassThrough={isPassThroughEnabled}
                            jobCostingExecutePermission={hasJobCostingExecutePermission}
                            allowEditVatPartner={allowEditVatPartner}
                            isSourceAthena={this.props.isSourceAthena}
                            isRevenue={this.props.target === CostColumnsData.TYPES.REVENUE}
                            vatPartnersOptions={this.getVatPartnerOptions(this.state.currentData?.vatPartner)}
                            vatPartnersData={this.props.vatPartnersData}
                            vatPartnerEditReasons={this.props.vatPartnerEditReasons}
                            vatPartnerEditReasonSelectOptions={this.props.vatPartnerEditReasonSelectOptions}
                            isAmendRatesEnabled={this.checkIfAmendRatesEnabled(materialCode)}
                            enableAmendRatesButton={enableAmendRatesButton}
                            additionalFields={athenaRateAdditionalFields}
                            disableAthenaFields={disableAthenaFields}
                            showRetriveAndAmendButtons={this.state.showRetriveAndAmendButtons}
                            showReasonCodeDropdown={showReasonCodeDropdown}
                            athenaBillToParty={this.state.athenaBillToParty}
                            athenaNetValue={this.state.athenaNetValue}
                            isAmendingAutoRates={isAmendingAutoRates}
                            isAutoRate={this.state.isAutoRate}
                            showErrorModal={this.showErrorModal}
                            showServiceProvider={showServiceProvider}
                            isNegativeRateAllowed={isNegativeRateAllowed}
                            isInsertedByUser={isInsertedByUser}
                            isSplitMode={this.state.isSplitMode}
                            showInternalReferenceNumber={this.showInternalReferenceNumber()}
                        />}
                    {this.state.dData && this.props.shouldDisplay &&
                        <DialogTableWrapper
                            classNameString={this.state.highlightTable ? 'highlight-table' : ''}
                            data={[...this.state.dData]}
                            columns={this.showTable()}
                            subColumns={this.state.currentData.children}
                            targetFunctionality={this.props.targetFunctionality}
                            updateChildren={this.state.shouldUpdate}
                            displayDistribution={this.state.currentData.displayDistribution}
                            distribution={this.state.currentData.distribution}
                            showSub={this.state.isExpanded}
                            target={this.state.target}
                            type={this.state.type}
                            index={this.state.currentIndex}
                            setCurrentIndex={this.onTargetClick}
                            isEditable={this.state.currentData.distribution === 3 || this.state.currentData.distribution === '3'}
                            isSelectable={true}
                            fetchData={this.tableOrderFetch}
                            subTableRef={this.state.subTable}
                            quantity={this.state.currentData.quantity}
                            onSelectCallBack={(e: any) => this.selectAllChildren(e)}
                            onUpdateCallback={(e: any, inx: number, bol: boolean) => this.onChildrenUpdate(e, inx, bol)}
                            returnRef={(e: any) => this.setState({ table: e })}
                            isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                            closeMethod={this.closeDialog}
                            deleteCharge={this.deleteChargeItem}
                        />}
                    {this.state.isSplitMode && this.state.splitStrategy && this.props.shouldDisplay &&
                        <SplitSelectionTable
                            rows={this.state.splitRows}
                            label={this.state.splitStrategy.title}
                            numberLabel={this.state.splitStrategy.numberLabel}
                            onChange={this.onSplitSelectionChange}
                        />}
                </div>
                <div>
                    {this.getButtons()}
                </div>
            </div>
        );
    }
    public tableOrderFetch = (target: any, tableData: any) => {
        if (tableData.state.sorted && tableData.state.sorted[0]) {
            const tData: any = this.state.dData;
            const dataType = tableData.sorted && tableData.sorted[0] ? this.showTable().find((column: any) => column.accessor === tableData.sorted[0].id)?.dataType : '';
            this.setState({ dData: sortElementByKey(tData, tableData.state.sorted[0].id, tableData.state.sorted[0].desc, dataType) });
        }
    };
    public closeDialog = () => this.setState({ showDialog: false, errorMessage: '' });

    public getButtons = () => {
        return <nav className="col-30 align-text-right">
            <Button
                type="button"
                id="btn-save"
                onClick={(e: any) => { e.preventDefault(); this.submitData(); }}
                buttonType={ButtonType.Blue}>
                Save
            </Button>&nbsp;
            <Button
                type="button"
                id="btn-cancel"
                onClick={(e: any) => { e.preventDefault(); this.onClose(); }}
                buttonType={ButtonType.Transparent}>
                Cancel
            </Button>
        </nav>;
    };

    public verifyChildren = (data: any = this.state.currentData) => {
        const resp: any[] = [];
        data.children.map((el: IQty) => {
            resp.push(el.QuantityPercentage);
        });
        return resp;
    };
    public selectAllChildren = (e: any[]) => {
        const newData: any[] = [...this.state.dData];
        if (e === null) {
            this.setState({
                shouldUpdate: false
            });
        } else {
            newData[this.state.currentIndex].children = newData[this.state.currentIndex].children.map((child: any, index: number) => {
                child.Select = e[index];
                return child;
            });
            this.setState({
                shouldUpdate: true
            });
        }
        newData[this.state.currentIndex] = this.calculateDistribution(newData[this.state.currentIndex]);
        this.setState({
            dData: newData,
            currentData: newData[this.state.currentIndex]
        });
    };
    public getTitle = (): string => {
        const _data = [...this.props.data];
        const str_last = (this.props.type && this.props.type === currentPageMode.edit && this.state.dData && this.state.dData.length > 0)
            ? `item # ${_data[this.state.currentIndex].essoRateDetailId}` : this.props.salesOrderNumber && this.props.target === CostColumnsData.TYPES.COST ? `Charge Item for SO :  ${this.props.salesOrderNumber}` : 'Charge Item';
        const str: string = `${this.props.type} ${str_last}`;
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    public persistTotals = (currSelectedIndex: any) => {
        currSelectedIndex = convertNumbers(currSelectedIndex);
        currSelectedIndex.total = calculateTotal(false, currSelectedIndex);
        currSelectedIndex.totalLocalCurrency = calculateTotal(true, currSelectedIndex);
        this.callFooterUpdate();
        return currSelectedIndex;
    };
    public callFooterUpdate = () => {
        if (this.myDialog.current) {
            updateFooterTotals(this.myDialog.current, [...this.state.dData], '.BookingDialogTable');
        }
    };
    public initChargesDropDown = () => {
        const chargeItem: any = formatDropDown(this.props.materialMasterList, ['materialNo', 'name'], 'materialNo');
        const oldConfig: any = { ...this.state.dropDownData };
        oldConfig.chargeItem = chargeItem;
        oldConfig.partyData = this.props.partyData;
        this.setState({
            dropDownData: oldConfig
        });
    };
    public onChildrenUpdate = (value: any, index: number, bol: boolean) => {
        const t: any[] = [...this.state.dData];
        t[this.state.currentIndex].children[index].Select = bol;
        if (t[this.state.currentIndex].displayDistribution && t[this.state.currentIndex].distribution === 3) {
            t[this.state.currentIndex].children[index].QuantityPercentage = Number(value);
        }
        if (t[this.state.currentIndex].distribution !== 3) {
            t[this.state.currentIndex] = this.calculateDistribution(t[this.state.currentIndex]);
        }
        this.setState({
            dData: t
        });
    };
    public onUpdate = (key: any, value: any, label: string) => {
        let currentIndex = [...this.state.dData];
        let newError: any = this.state.errorList;
        let splitStateUpdate: any = {};
        newError = newError.filter((item: any) => {
            return item !== key;
        });
        if (key === 'passThrough') {
            currentIndex[this.state.currentIndex].passThrough = value === 1 ? 'Y' : 'N';
        } else {
            currentIndex[this.state.currentIndex][key] = value;
        }
        // Flag an out-of-range/non-alphanumeric IRN as soon as the field is left,
        // instead of waiting for the save attempt.
        if (key === 'internalReferenceNumber' && getInternalReferenceNumberError(value)) {
            newError = [...newError, key];
        }
        currentIndex[this.state.currentIndex] = this.persistTotals(currentIndex[this.state.currentIndex]);
        if (key === 'chargeItem' && currentIndex[this.state.currentIndex].chargeItem) {
            if (this.props.isSourceAthena) {
                this.checkForAdditionalFields(Number(currentIndex[this.state.currentIndex].chargeItem));
                const isRevenue = this.props.target === CostColumnsData.TYPES.REVENUE;
                const isAdding = this.props.type === currentPageMode.add;
                const disabledAthenaFields = this.state.athenaRateFormData[this.state.currentData.id]?.disableAthenaFields;
                if (disabledAthenaFields && isAdding) {
                    const updatedItem = {
                        ...currentIndex[this.state.currentIndex],
                        rate: 0,
                        condCurrency: disabledAthenaFields ? '' : 'CNY',
                        passThrough: '',
                        serviceRenderedAt: '',
                        ...(isRevenue && { billToParty: '' }),
                    };
                    currentIndex[this.state.currentIndex] = updatedItem;
                }
            }
            persistMaterialInfo(currentIndex[this.state.currentIndex], this.props.materialMasterList);
            // Reset split mode for the newly selected charge; its rules are fetched (by
            // chargeCode) and the split state is applied asynchronously once they arrive.
            splitStateUpdate = { isSplitMode: false, splitStrategy: null, splitRows: [], selectedSplits: [] };
            // Leaving split mode: clear the auto-populated combined quantity so it doesn't
            // linger on the newly selected charge (loadSplitRulesForCharge re-populates it if
            // the new charge is also split).
            if (this.state.isSplitMode) {
                currentIndex[this.state.currentIndex].quantity = 0;
            }
            this.loadSplitRulesForCharge(currentIndex[this.state.currentIndex].materialCode);
        }
        if (key === 'uom' && this.props.type === currentPageMode.add) {
            switch (currentIndex[this.state.currentIndex].uom) {
                case 'DOC':
                case 'EA':
                case 'H':
                    currentIndex[this.state.currentIndex].distribution = 2;
                    break;
                default:
                    currentIndex[this.state.currentIndex].distribution = 1;

            }
        }

        if (currentIndex[this.state.currentIndex].distribution && !isNaN(currentIndex[this.state.currentIndex].quantity) && Number(currentIndex[this.state.currentIndex].quantity) > 0) {
            currentIndex[this.state.currentIndex] = this.calculateDistribution(currentIndex[this.state.currentIndex]);
        }
        if (this.props.type === currentPageMode.add) {
            currentIndex = this.shouldDisplayDist(currentIndex);
        }
        this.setState({
            errorList: newError,
            dData: currentIndex,
            currentData: currentIndex[this.state.currentIndex],
            ...splitStateUpdate
        });
    };

    public shouldDisplayDist = (data: any[]) => {
        if (this.props.type === currentPageMode.add && this.isAthenaEnabled() && !typeAndSizeCheck(this.state.dData)) {
            data[this.state.currentIndex].displayDistribution = true;
            return data;
        }
        if (data[this.state.currentIndex].uom && data[this.state.currentIndex].chargeItem &&
            data[this.state.currentIndex].quantity && (data[this.state.currentIndex].billToParty || data[this.state.currentIndex].payToParty)) {
            data[this.state.currentIndex].displayDistribution = true;
        } else {
            data[this.state.currentIndex].displayDistribution = false;
        }
        return data;
    };

    public calculateDistribution = (currentIndex: any) => {
        const leng = currentIndex.children.filter((child: any) => {
            if (child.Select === undefined) {
                child.Select = true;
            }
            return child.Select === true;
        });

        if (currentIndex.displayDistribution) {
            const Q = Number(currentIndex.quantity);
            const N = leng.length;

            if (N > 0) {
                const P = Math.round(Q * 1000);
                const base = Math.floor(P / N);
                const R = P % N;
                let selectedIndex = 0;

                currentIndex.children = currentIndex.children.map((el: any, index: number) => {
                    if (el.Select && currentIndex.distribution !== 3) {
                        if (selectedIndex < R) {
                            el.QuantityPercentage = ((base + 1) / 1000).toFixed(3);
                        } else {
                            el.QuantityPercentage = (base / 1000).toFixed(3);
                        }
                        selectedIndex++;
                    } else {
                        el.QuantityPercentage = '0.000';
                    }

                    const thisIndex: any = { ...this.state.dData[this.state.currentIndex] };
                    const ind = thisIndex.children[index];
                    ind.QuantityPercentage = el.QuantityPercentage;
                    ind.quantity = el.QuantityPercentage;

                    return el;
                });
            } else {
                currentIndex.children = currentIndex.children.map((el: any, index: number) => {
                    el.QuantityPercentage = '0.000';
                    const thisIndex: any = { ...this.state.dData[this.state.currentIndex] };
                    const ind = thisIndex.children[index];
                    ind.QuantityPercentage = el.QuantityPercentage;
                    ind.quantity = el.QuantityPercentage;
                    return el;
                });
            }
        }

        return currentIndex;
    };

    public onClose = () => {
        this.props.onClose(this.props.target);
    };
    public onTargetClick = (index: number) => {
        this.setState({
            currentIndex: index,
            currentData: { ...this.state.dData[index] },
            errorList: [],
            errorMessage: ''
        });
    };
    public nextPrevClick = (direction: number = 0) => {
        const newIndex = this.state.currentIndex + direction;
        this.onTargetClick(newIndex);
    };

    public isVatPartnerChanged = (index: number, vatPartner: string) => {
        const currentVatPartner = this.props.data[index]?.vatPartner ?? '';
        const changedVatPartner = vatPartner ?? '';
        return currentVatPartner !== changedVatPartner;
    };

    public isAutoRateVatPartnerChanged = (item: any) => {
        const originalAthenaRateChargeItems = this.state.originalAthenaRateChargeItems;
        const parsedOriginalAthenaRateChargeItems = originalAthenaRateChargeItems?.map((chargeItem: any) => JSON.parse(chargeItem));
        const originalChargeItem = parsedOriginalAthenaRateChargeItems.find((chargeItem: any) => {
            return chargeItem?.id === item.id;
        });
        return originalChargeItem?.vatPartner === item.vatPartner;
    };

    // IRN is captured on Export revenue charges only
    public showInternalReferenceNumber = () => {
        return !this.props.isDestination &&
            this.props.target === CostColumnsData.TYPES.REVENUE &&
            isFeatureEnabled(FEATURE_TOGGLES.FINOPS_KMART_WSI_NON_STANDARD_FCR, this.props.featureToggles);
    };

    public validateData = () => {
        this.setState({ showDialog: false });
        const isPassThroughEnabled = isFeatureEnabled(FEATURE_TOGGLES.ENABLE_PASSTHROUGH, this.props.featureToggles);
        const currData = { ...this.state.dData[this.state.currentIndex] };
        let errorMsg = '';
        const allowEditVatPartner = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ENABLE_VATPARTNER_AMENDMENT, this.props.featureToggles);
        const isRevenue = this.props.target === CostColumnsData.TYPES.REVENUE;

        if (isRevenue && this.props.type === currentPageMode.edit) {
            errorMsg = costAndRevErrorMessage.errorMsgRev;
        } else if ((this.props.target === CostColumnsData.TYPES.COST && this.props.type === currentPageMode.edit)) {
            errorMsg = costAndRevErrorMessage.errorMsgCost;
        }
        const canEditAthena = currData.updatedBy !== ATHENA && this.props.isSourceAthena;
        const checkValid = this.props.target === CostColumnsData.TYPES.COST ?
            checkIsValid(currData, CostColumnsData.requiredCostData(isPassThroughEnabled, canEditAthena)) :
            checkIsValid(currData, CostColumnsData.requiredRevenueData(isPassThroughEnabled, canEditAthena));
        let validReasonCode = true;
        let validNewICCode = true;
        let validEditVatPartnerReason = true;
        let validInternalReferenceNumber = true;
        let internalReferenceNumberError = '';
        const showIrn = this.showInternalReferenceNumber();
        this.state.dData.forEach((item: any, index) => {
            const irnError = showIrn ? getInternalReferenceNumberError(item.internalReferenceNumber) : '';
            if (irnError) {
                checkValid.invalidKeys.push('internalReferenceNumber');
                checkValid.invalidList.push(irnError);
                validInternalReferenceNumber = false;
                internalReferenceNumberError = irnError;
            }
            if (!this.state.isAutoRate && allowEditVatPartner && isRevenue && this.isVatPartnerChanged(index, item.vatPartner) && !item?.vatPartnerReasonCodeNo) {
                checkValid.invalidKeys.push('vatPartnerReasonCodeNo');
                checkValid.invalidList.push('A Reason Code for VAT Partner edit must be selected');
                validEditVatPartnerReason = false;
            }
            if (allowEditVatPartner && isRevenue && this.state.isAutoRate && !item?.vatPartnerReasonCodeNo && this.state.originalAthenaRateChargeItems?.length) {
                validEditVatPartnerReason = this.isAutoRateVatPartnerChanged(item);
                if (!validEditVatPartnerReason) {
                    checkValid.invalidKeys.push('vatPartnerReasonCodeNo');
                    checkValid.invalidList.push('A Reason Code for VAT Partner edit must be selected');
                }
            }
            if (this.props.type === currentPageMode.add && this.state.originalAthenaRateChargeItems?.length && !item.reasonCode && item.AdhocContractualAmendmentIdentifier) {
                checkValid.invalidKeys.push('reasonCode');
                checkValid.invalidList.push('A reason code must be selected');
                validReasonCode = false;
            }
            if (this.props.type === currentPageMode.edit) {
                if (allowEditVatPartner && isRevenue && this.isVatPartnerChanged(index, item.vatPartner) && !item.vatPartnerReasonCodeNo) {
                    checkValid.invalidKeys.push('vatPartnerReasonCodeNo');
                    checkValid.invalidList.push('A Reason Code for VAT Partner edit must be selected');
                    validEditVatPartnerReason = false;
                }
                if (!item.reasonCode && checkIfSystemType([item])) {
                    checkValid.invalidKeys.push('reasonCode');
                    checkValid.invalidList.push('A reason code must be selected');
                    validReasonCode = false;
                }
                if (this.props.target === CostColumnsData.TYPES.COST) {
                    if (this.props.data[index].payToParty && this.state.dData[index].icbIndicator !== this.props.data[index].icbIndicator) {
                        validNewICCode = false;
                        checkValid.invalidKeys.push('icbIndicator');
                        checkValid.invalidList.push(errorMsg);
                    }
                }
                if (isRevenue) {
                    if (this.state.dData[index].icbIndicator !== this.props.data[index].icbIndicator) {
                        validNewICCode = false;
                        checkValid.invalidKeys.push('icbIndicator');
                        checkValid.invalidList.push(errorMsg);
                    }
                }
            };
            // Split rows carry a derived, non-editable quantity — skip the manual-entry limits.
            if (item.splitReferenceType) {
                // no-op
            }
            else if (item.quantity > 999999999) {
                checkValid.invalidKeys.push('quantity');
                checkValid.invalidList.push(`${costAndRevErrorMessage.errorMsgQuantity}`);
                checkValid.isValid = false;
                this.setState({
                    isQantityvalidation: false
                });
            }
            else if (item.uom === 'CNT' || item.uom === 'DOC' || item.uom === 'EA' || item.uom === 'PAL') {
                const quantitySavedata = Number(item.quantity.toString().split('.')[0]);
                if (quantitySavedata > 999) {
                    checkValid.invalidKeys.push('quantity');
                    checkValid.invalidList.push(`${costAndRevErrorMessage.errorMsgQuantityNew}`);
                    checkValid.isValid = false;
                    this.setState({
                        isQantityvalidation: true
                    });
                }
            } else {
                this.setState({
                    isQantityvalidation: false
                });
            }

        });

        const validateAll: any = this.state.dData && this.state.dData.length >= 1 ? validateAllData([...this.state.dData], this.props.target) : false;
        if (checkValid.isValid
            && (validateAll
                && validateAll.totalInvalid === 0)
            && validReasonCode && validEditVatPartnerReason
            && validNewICCode && validInternalReferenceNumber) {
            this.setState({
                showDialog: false,
                errorMessage: '',
                errorList: []
            });
            return checkValid.isValid;
        } else {
            const inValidItemList = String(checkValid.invalidList).replace(/,(?=[^\s])/g, ', ');
            let msg = this.state.dData.length > 1 ?
                `${validateAll.totalInvalid} Charge item(s) is (are) pending review before saving : ${inValidItemList}`
                : `Please fill all the required fields before saving: ${inValidItemList}`;
            if (!validReasonCode && this.state.dData.length > 1) {
                msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} A reason code must be selected.`;
            }
            if (!validEditVatPartnerReason && this.state.dData.length > 1) {
                msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} A reason code for vat partner edit must be selected.`;
            }
            if (!validNewICCode && this.state.dData.length > 1) {
                msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} ${errorMsg}.`;
            }
            if (!validInternalReferenceNumber && this.state.dData.length > 1) {
                msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} ${internalReferenceNumberError}.`;
            }
            this.setState({
                showDialog: true,
                errorMessage: msg,
                errorList: checkValid.invalidKeys
            });
        }
        return false;
    };

    public isAtLeastOneSelected = () => {
        const resp: boolean[] = [];
        const checkList: boolean[] = [];
        this.state.dData.forEach((element: any) => {
            let isSelected: boolean = false;
            element.children.map((el: any) => {
                if (el.Select === true) {
                    isSelected = true;
                }
                return el;
            });
            checkList.push(this.isCountValid(element));
            resp.push(isSelected);
        });
        if (resp.indexOf(false) === -1 && checkList.indexOf(false) === -1) {
            return true;
        }
        else if (checkList.indexOf(false) > -1) {
            const list: any[] = [];
            resp.forEach((el: boolean, index: number) => {
                if (!el) {
                    return list.push(index + 1);
                }
                return el;
            });
            const item = resp.length > 1 ? `items ${String(list).replace(/,(?=[^\s])/g, ', ')}` : `Item ${String(list)}`;
            const msg = `Review quantity items: ${item}. ${CostAndRevenue.Error_Quantity_Sum} `;
            this.setState({
                showDialog: true,
                errorMessage: msg,
                errorList: []
            });
        }
        else {
            const list: any[] = [];
            resp.forEach((el: boolean, index: number) => {
                if (!el) {
                    return list.push(index + 1);
                }
                return el;
            });
            const item = resp.length > 1 ? `items ${String(list).replace(/,(?=[^\s])/g, ', ')}}` : `Item ${String(list)}`;
            const msg = `${CostAndRevenue.Error_Review_Distribution} ${item}.${CostAndRevenue.Error_Select_Distribution}`;
            this.setState({
                showDialog: true,
                errorMessage: msg,
                errorList: []
            });
        }
        return false;
    };
    public isCountValid = (el: any): boolean => {
        let count = 0;
        const maxQ = el.quantity;
        el.children.map((e: any) => {
            if (e.Select) {
                const newNum = Number(e.QuantityPercentage);
                count += isNaN(newNum) ? 0 : newNum;
            }
        });
        return Number(Math.round(count)) === Number(Math.round(maxQ)) || this.props.targetFunctionality === targetFunctionality.ETS;
    };
    public checkTypes = () => {
        if (!typeAndSizeCheck(this.state.dData, true)) {
            this.setState({
                showDialog: true,
                errorMessage: CostAndRevenue.Error_Multiple_Size_Type
            });
            return false;
        } else {
            return true;
        }
    };
    public submitData = () => {
        const originalAthenaRateChargeItems = this.state.originalAthenaRateChargeItems;
        const closeAfterSave = originalAthenaRateChargeItems.length ? false : true;
        if (this.validateData() && ((this.props.type === currentPageMode.add && this.isAtLeastOneSelected())
            || (this.props.type === currentPageMode.edit && this.isAtLeastOneSelected())) &&
            ((this.props.type === currentPageMode.add && this.checkTypes()) || this.props.type === currentPageMode.edit)) {
            this.setState({
                showDialog: false,
                errorMessage: ''
            });
            const isEditing = this.props.type === currentPageMode.edit;
            const isAdding = this.props.type === currentPageMode.add;
            const resp = this.state.dData.map((element: any) => {
                if (isAdding) {
                    element.itemType = this.props.isSourceAthena && this.state.isAutoRate ? ATHENA : this.props.nickname.employeeId;
                }
                element.passThrough = element.passThrough || 'N';
                element = persistMaterialInfo(element, this.props.materialMasterList);
                element.updatedBy = this.props.nickname.employeeId;
                element.specialPricingCondition = isEditing ? 'N' : element.specialPricingCondition;
                element.errorReason = this.generateErrorReason(element);
                convertNumbers(element);
                return element;
            });

            if (originalAthenaRateChargeItems.length) {
                originalAthenaRateChargeItems.forEach((chargeItem: any) => {
                    const originalChargelItem = JSON.parse(chargeItem);
                    originalChargelItem.itemType = ATHENA;
                    originalChargelItem.errorReason = this.generateErrorReason(originalChargelItem);
                    const index = resp.findIndex((item: any) => item.id === originalChargelItem.id);
                    originalChargelItem.children = this.state.dData[index].children;
                    this.setState((prevState) => {
                        return {
                            editedAthenaRateChargeItems: {
                                ...prevState.editedAthenaRateChargeItems,
                                [index]: {
                                    ...this.state.dData[index],
                                }
                            }
                        };
                    });
                    if (index > -1) {
                        resp[index] = originalChargelItem;
                    }
                });
            }
            this.props.onSave(resp, this.props.target, closeAfterSave);
        }
    };

    public generateErrorReason = (element: any) => {
        const isAdding = this.props.type === currentPageMode.add;
        const vatPartnerHasValue = element.vatPartner && element.vatPartner.toLowerCase() !== 'not available';

        if (!isAdding) {
            if (element.vatPartner && element.vatPartner.toLowerCase() === 'not available') {
                return 'VAT Partner not found';
            } else {
                return '';
            }
        }

        if (this.state.isAutoRate) {
            if (vatPartnerHasValue && element.VatPartnerValueError) {
                return '';
            } else if (!vatPartnerHasValue && !element.VatPartnerValueError && element.vatPartner === '') {
                return '';
            } else if (!vatPartnerHasValue && element.VatPartnerValueError) {
                return element.VatPartnerValueError;
            }
        }

        return element.handleError ? '' : element.errorReason;
    };

    public onAddClick = () => {
        if (this.state.dData.length <= 9) {
            const emtpyData: any = JSON.parse(JSON.stringify(this.props.data))[0];
            emtpyData.itemType = this.props.isSourceAthena ? ATHENA : this.props.nickname.employeeId;
            emtpyData.insertBy = this.props.nickname.employeeId;
            emtpyData.delete = 'Remove';
            const lastId: any = this.state.dData.slice(-1)[0].id;
            emtpyData.id = lastId + 1;
            if (this.props.target === CostColumnsData.TYPES.COST) {
                emtpyData.itemCategory = CostColumnsData.TYPES.COST;
            } else {
                emtpyData.itemCategory = 'REV';
            }
            const newIndex = this.state.currentIndex + 1;
            emtpyData.children = JSON.parse(JSON.stringify(emtpyData.children));
            emtpyData.children.map((el: any, index: number) => {
                el.id = `${emtpyData.id}.${index}`;
                el.quantity = 0;
                el.QuantityPercentage = 0;
                el.Select = true;
            });
            const newData = [...this.state.dData, { ...emtpyData }];
            this.setState({
                currentIndex: newIndex,
                currentData: { ...emtpyData },
                dData: newData,
            }, () => {
                this.checkAthenaFieldsStatus();
            });
            this.callFooterUpdate();
        } else {
            this.setState({
                isAddMoreDisable: true
            });
        }
    };
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    nickname: state.nickname.userNickName,
    materialMasterList: state.materialMaster.materialMasterList,
    vendors: state.vendors.vendors,
    vendorsError: state.vendors.pendingError,
    billToPartnersRawData: state.billToParty.partnersRawData,
    customerlMasterList: state.materialMaster.customerMasterList,
    reasonCodes: state.mdm.reasonCodes,
    featureToggles: state.featureToggle.featureToggles,
    vatPartnersData: state.vatPartnerEdit.vatPartnersData,
    vatPartnersOptions: state.vatPartnerEdit.vatPartnersOptions,
    vatPartnerEditReasons: state.vatPartnerEdit.vatPartnerEditReasonCodesData,
    vatPartnerEditReasonSelectOptions: state.vatPartnerEdit.vatPartnerEditReasonSelectOptions,
    userPermissions: state.user.userPermissions,
    amendmentExceptions: state.athena.amendmentExceptions,
    athenaOptionalChargeRateRetrieval: state.athena.athenaOptionalChargeRateRetrieval,
    chargeSplitRules: state.athena.chargeSplitRules,
    additionalFieldsResponse: state.athena.materialCodeAdditionalAttributes,
    athenaRateRetrieveError: state.athena.adHocContractualRatesError,
    athenaRetrieveRateResponse: state.athena.adHocContractualRates?.addedCharges[0],
    exportJob: state.exportJob,
    etsJob: state.ets,
    feedbackResponse: state.costRevenue.newCode,
    partners: state.partners.partners.result,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    getMaterialMaster: () => dispatch(getMaterialMaster()),
    fetchCustomerMaster: () => dispatch(fetchCustomerMaster()),
    fetchVendors: (country: string, company: string, org: string) => dispatch(fetchVendors(country, company, org)),
    resetParties: () => dispatch(resetParties()),
    getReasonCodes: (category: string) => dispatch(getReasonCodes(category)),
    fetchVatPartners: () => dispatch(fetchVatPartners()),
    fetchVatPartnerEditReasons: () => dispatch(fetchVatPartnerEditReasons()),
    fetchExportJobBookingDetails: (exportJobId: number) => dispatch(fetchExportJobBookingDetails(exportJobId)),
    getMaterialCodeAttributes: (customerBeCode: string) => dispatch(getMaterialCodeAttributes(customerBeCode)),
    getChargeAmendmentExceptions: (customerBeCode: string) => dispatch(getChargeAmendmentExceptions(customerBeCode)),
    getAthenaOptionalChargeRateRetrieval: (customerBeCode: string) => dispatch(getAthenaOptionalChargeRateRetrieval(customerBeCode)),
    getChargeSplitRules: (contractualParty: string, shipmentType: string, chargeCode: string) => dispatch(getChargeSplitRules(contractualParty, shipmentType, chargeCode)),
    getAdhocContractualRates: (documentType: string, requestObject: any) => dispatch(getAdhocContractualRates(documentType, requestObject)),
    fetchVatPartnerValue: (documentType: string, requestObject: any) => dispatch(fetchVatPartnerValue(documentType, requestObject)),
    checkVendor: (code: { beCode?: string; factCode?: string; }) => dispatch(checkVendor(code)),
    fetchPartners: (type: number, valueId: any) => dispatch(fetchPartners(type, valueId)),
});
export const AddEditDialog = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_AddEditDialog);
